import React from 'react';
import { OAuthLink, OAuthProviderType } from 'nekst-api';
import { IconDeleteButton, CardLayout } from 'features/nekst-widgets';
import googleIcon from './google.png';
import appleIcon from './apple.png';

interface OAuthLinkItemProps {
  link: OAuthLink;
  onDisconnect: (linkId: number) => Promise<void>;
}

export default function OAuthLinkItem({ link, onDisconnect }: OAuthLinkItemProps) {

  const getProviderIcon = () => {
    switch (link.provider) {
      case OAuthProviderType.GOOGLE:
        return <img src={googleIcon} alt="Google" width="24" height="24" />;
      case OAuthProviderType.APPLE:
        return <img src={appleIcon} alt="Apple" width="24" height="24" />;
      default:
        return <img src={googleIcon} alt="Provider" width="24" height="24" />;
    }
  };

  const getProviderName = () => {
    switch (link.provider) {
      case OAuthProviderType.GOOGLE:
        return 'Google';
      case OAuthProviderType.APPLE:
        return 'Apple';
      default:
        return link.provider;
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <CardLayout
      icon={getProviderIcon()}
      title={`${getProviderName()} Account`}
      subtitle={link.email}
      meta={`Connected on ${formatDate(link.createdAt)}`}
      actions={
        <IconDeleteButton
          deleteFunc={async () => {
            await onDisconnect(link.id);
          }}
          message={`Are you sure you want to disconnect your ${getProviderName()} account?`}
        />
      }
    />
  );
}